// extracted by mini-css-extract-plugin
export default {"item":"index_item_m771I"};